import {createSelector} from 'reselect';
import isLegacySite from '../utils/isLegacySite';
import {getSiteCode} from './selectors';

export default createSelector(
  [getSiteCode],
  siteCode => isLegacySite(siteCode),
);
